export default __webpack_public_path__ + "static/media/profile.54335056.jpg";